module.exports = __webpack_public_path__ + "static/1f0709a860a30ac772641c1c0978d977dd23196f2b7504a34465a2f9f1d4ceeb-ca6cdc9d34412f11a58d205f0b3515d9.jpeg";